export const IFRAME_ORIGIN = 'https://pay.wix.com';
const IFRAME_BASE_URL = `${IFRAME_ORIGIN}/cards/form`;
/**
 * @param {Object} iframeParams
 * @param {String[]} iframeParams.fields
 * @param {String[]} iframeParams.networks
 * @param {String} iframeParams.countryCode
 * @param {String} iframeParams.locale
 * @param {String} [iframeParams.theme] - default to 'light'
 * @param {Boolean} [iframeParams.isMobile] - default to false
 */

export function buildIFrameUrl(iframeParams) {
  if (!iframeParams) throw new Error('iframeParams must be an object');
  if (!iframeParams.fields || !iframeParams.networks || !iframeParams.countryCode || !iframeParams.locale) {
    throw new Error('you are missing one of the required params [fields, networks, countryCode, locale]');
  }
  return `${IFRAME_BASE_URL}?params=${window.btoa(
    JSON.stringify({
      theme: 'light',
      spinnerRadius: iframeParams.isMobile ? 65 : 30,
      focusOnMount: true,
      isMobile: false,
      ...iframeParams,
    }),
  )}`;
}

/**
 * @param {Function} onHeight - On iframe load, set the iframe container height according the iframe height. param is the height.
 * @param {Function} onSubmit - On iframe done clicked. param is the token
 * @param {Function} onClose - on iframe close clicked
 * @returns {Function} unsubscribed function.
 */
export function subscribeToIframeMessages({ onHeight, onSubmit, onClose }) {
  function handleMessages(event) {
    // Check that we trust the sender of this message
    if (event.origin !== IFRAME_ORIGIN) {
      return;
    }

    const { data = {} } = event;

    // Deal with onload, set the iframe container height according the iframe height
    if (data.height) {
      onHeight(data.height);
    }

    // Deal with token (means the OK was clicked)
    if (data.token) {
      onSubmit(data.token);
    }

    if (data.message === 'close') {
      onClose();
    }
  }
  window.addEventListener('message', handleMessages, false);

  return () => window.removeEventListener('message', handleMessages, false);
}
